<script>
import Vue from "vue";
import qs from "qs";

// 以分钟为单位，设置localStorage过期时间，用于存储服务器数据
let localStorageUtil = {
  set(key, val, expire) {
    let exp = expire ? Date.now() + expire * 1000 * 60 : -1;
    localStorage.setItem(key, JSON.stringify({ value: val, expire: exp }));
    // console.log('set ok', JSON.stringify({value: val, expire: new Date(exp).toLocaleString()}));
  },
  get(key) {
    let data = localStorage.getItem(key);
    // console.log(data);

    if (!data) return null;

    let dataObj = JSON.parse(data);

    if (dataObj.expire == -1) return dataObj.value;

    if (Date.now() >= dataObj.expire) {
      localStorage.removeItem(key);
      return null;
    } else {
      return dataObj.value;
    }
  }
};

function commonFun() {
  console.log("调用公共方法");
}

export default {
  commonFun,
  localStorageUtil,
};
</script>





// WEBPACK FOOTER //
// src/components/common.vue